import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { Spinner } from "reactstrap";
import axios from "axios";
import Dropdown from "../../components/page/map/Dropdown/ClientImpersonationDropdown";
import Button from "../../components/general/Button/Button";

import PrivateRouteWrapper from "../../wrappers/PrivateRouteWrapper";
import Header from "../../components/wrapper/Header/Header";
import SideBar from "../../components/wrapper/SideBar/ClientImpersonationSideBarTemp";
import Content from "../../components/wrapper/Content/Content";
import MapPageTemp from "../client/MapPageTemp";
import Loading from "../../components/wrapper/Loading/Loading";
import * as actionTypes from "../../store/actions/actionTypes";

import truckColors from "../../assets/truckRouteColors";
import blendedColors from "../../assets/blendedRouteColors";
import macroColors from "../../assets/macroRouteColors";
import repColors from "../../assets/repRouteColors";
import AnalyticsPageTemp from "../client/AnalyticsPageTemp";
import _ from "lodash";

const inventoryCampaigns = {
  LA: 71,
  NYC: 72,
  SF: 73
};

const initialState = {
  loading: false,
  loadedUser: false,
  client: {
    name: "Client",
    id: -1
  },
  campaigns: {},
  showDropdown: false,
  heatmapView: true,
  selectedTimePeriod: '1W'
};
class ClientImpersonationPageTemp extends Component {
  state = {
    loading: false,
    loadedUser: false,
    client: {
      name: "Client",
      id: this.props.match.params.client_id
    },
    campaigns: {},
    showDropdown: false,
    heatmapView: true,
    selectedTimePeriod: '1W'
  };
  componentDidMount() {
    console.log('client_id', this.props.match.params.client_id);
    console.log('campaign_id', this.props.match.params.campaign_id);
    if (this.props.match.params.client_id) {
      this.loadUser(this.props.timePeriod, true, this.props.campaigns[this.props.match.params.campaign_id]);
      this.loadUserDetail(this.props.match.params.client_id)
      this.getClientName(this.props.match.params.client_id);
    }
  }

  toggleDropdown = () => {
    let current_state = this.state.showDropdown;
    this.setState({
      showDropdown: !current_state,
    });
  };
  changeCampaign = (campaign_id) =>{
    this.setState({
      showDropdown: false
    });
    this.props.history.push(`/dashboard/admin/advertise/client/impersonate/${this.props.match.params.client_id}/campaign/${campaign_id}/map`);

  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.props) {
      if (this.props.timePeriod !== prevProps.timePeriod || this.props.match.params.campaign_id !== prevProps.match.params.campaign_id || ( this.props.location.pathname.includes('map') !== prevProps.location.pathname.includes('map'))) {
        // this.props.updateCampaignVehiclesTemp(0, {})
        if (this.props.match.params.client_id && !this.state.loadedUser) {
          console.log('1st');
          this.loadUser(this.props.timePeriod, this.props.match.params.campaign_id !== prevProps.match.params.campaign_id ? true : false, prevProps.campaigns[this.props.match.params.campaign_id]);
          this.loadUserDetail(this.props.match.params.client_id)
          this.setState({
            loadedUser: true
          });
        } else {
          console.log('2nd');
          // check if vehicles exist if selected campaign changes
          if (prevProps.match.params.campaign_id !== this.props.match.params.campaign_id) {
            console.log('3rd');
            let selected = this.props.match.params.campaign_id;
            if (
              this.state.campaigns[selected] &&  this.props.location.pathname.includes('map')
            ) {
              let vehicles = await this.getVehicles(selected, this.props.timePeriod, true, prevProps.campaigns[this.props.match.params.campaign_id]);
              let clientName = await this.getClientName(this.props.match.params.client_id);
              this.props.onCampaignLoad(this.state.campaigns, selected);
              this.props.updateCampaignVehiclesTemp(selected, vehicles)
            }
          } else {
            console.log('4th');
            let selected = this.props.match.params.campaign_id;
            if (
              this.state.campaigns[selected] &&  this.props.location.pathname.includes('map')
            ) {
              let vehicles = await this.getVehicles(selected, this.props.timePeriod, false, prevProps.campaigns[this.props.match.params.campaign_id]);
              this.props.updateCampaignVehiclesTemp(selected, vehicles)
            }
          }
        }
      }
    }
  }

  componentWillUnmount() {
    let _campaigns = {
        "0": {
        name: "",
        boundingBox: [],
        vehicles: {},
        analytics: {}
      }
    }
    console.log('destroy');
    // this.props.updateCampaignVehiclesTemp(this.props.selected, {vehicles: {}, analytics: {}})
    // this.props.onCampaignLoad(_campaigns, -1);

    this.props.resetState()
    this.setState(initialState)
  }

  loadUserDetail(userId) {
    axios
      .get(`${process.env.REACT_APP_API_HOST}/user/${userId}`, { withCredentials: true })
      .then(async (response) => {
        
        let user = response.data.user[0];
        if(user?.user_id && user?.user_profile_image){
          this.props.updateProfilePicture(user?.user_profile_image)
        }
      })
  }

  loadUser(timePeriod, fetchAnalytics, campaign) {
    console.log("🚀 ~ file: ClientImpersonationPage.js:104 ~ ClientImpersonationPage ~ loadUser ~ timePeriod:", timePeriod)
    let inventory = this.props.match.params.inventory ? inventoryCampaigns[this.props.match.params.inventory] : null;
    axios
      .get(`${process.env.REACT_APP_API_HOST}/user/${this.props.match.params.client_id}/campaign`, { withCredentials: true })
      .then(async (response) => {
        let campaigns = {};
        let first = null;
        if (response.data.campaigns[0].id) {
          response.data.campaigns.map((campaign) => {
            if (!first) {
              first = campaign.id;
            }
            campaigns[campaign.id] = {
              name: campaign.name,
              vehicles: {},
              csv_report_enabled: campaign.csv_report_enabled,
              startDate: campaign.start_date,
              endDate: campaign.end_date
            };
          });

        }
        else {
          first = 0;
          campaigns[0] = {
            name: "",
            vehicles: {}
          };
        }
        if (first) {
          // load first campaigns routes
          campaigns[this.props.match.params.campaign_id].vehicles = await this.getVehicles(this.props.match.params.campaign_id, timePeriod, fetchAnalytics, campaign);
        }
        console.log(campaigns);
        this.setState({
          campaigns: campaigns
        });
        this.props.onCampaignLoad(campaigns, inventory ? inventory : this.props.match.params.campaign_id);
        this.props.updateCampaignVehiclesTemp(this.props.match.params.campaign_id, campaigns[this.props.match.params.campaign_id].vehicles)
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async getClientName(id){
    try{
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/user/${id}`, {withCredentials: true });
      if (res.status === 200){
        this.setState({
          client: {
            name: res.data.user[0].name,
            id: id,
          }
        });
      }
    }
    catch (err){
      console.log(err);
    }
  }

  async getVehicles(id, timePeriod, fetchAnalytics, campaign) {
    const tempCampaignVehicles = campaign ? _.cloneDeep(campaign?.vehicles) : {}
    this.setState({
      loading: true
    });
    let vehicles = {};
    let analytics = {};
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/campaign/${id}/truck/routes/${timePeriod}`, {
        withCredentials: true
      });
      if (res.status === 200) {
        res.data.trucks.map((truck, index) => {
          let colorIndex = index % truckColors.length;
          if (truck.id) {
            vehicles[`truck-${truck.id}`] = {
              imei: truck.imei,
              name: truck.display_name,
              paths: truck.paths,
              color: truckColors[colorIndex],
              checked: true,
            };
          }
        });
        res.data.blended.map((blended, index) => {
          let colorIndex = index % blendedColors.length;
          if (blended.paths && blended.paths.length > 0) {
            vehicles[`blended-${blended.id}`] = {
              name: blended.display_name,
              paths: blended.paths,
              color: blendedColors[colorIndex],
              checked: true,
            };
          }
        });
        res.data.placeholders.map((placeholder, index) => {
          let colorIndex = index % repColors.length;
          vehicles[`placeholder-${placeholder.id}`] = {
            name: placeholder.display_name,
            paths: placeholder.paths,
            color: repColors[colorIndex],
            checked: true,
          };
        });
        res.data.macros.map((macro, index) => {
          let colorIndex = index % macroColors.length;
          vehicles[`macro-${macro.id}`] = {
            name: macro.display_name,
            paths: macro.paths,
            color: macroColors[colorIndex],
            checked: true,
          };
        });

        // if (campaign) {
        //   for (let [key, value] of Object.entries(tempCampaignVehicles)) {
        //     for (let [key1, value1] of Object.entries(vehicles)) {
        //       if (key === key1) {
        //         value.paths = value1.paths
        //       }
        //     }
        //   }
        // }
      }


      if (true) {
        let res1 = await axios.get(`${process.env.REACT_APP_API_HOST}/campaign/${id}/truck/analytics`, {
          withCredentials: true
        });
  
        if (res1.status == 200) {
          res1.data.trucks.map((truck, index) => {
            if (truck.id) {
              analytics[`truck-${truck.id}`] = {
                analytics: truck.analytics
              };
            }
          });
          res1.data.blended.map((blended, index) => {
            if (blended.paths && blended.paths.length > 0) {
              analytics[`blended-${blended.id}`] = {
                analytics: blended.analytics,
              };
            }
          });
          res1.data.placeholders.map((placeholder, index) => {
            analytics[`placeholder-${placeholder.id}`] = {
              paths: placeholder.paths,
            };
          });
          res1.data.macros.map((macro, index) => {
            analytics[`macro-${macro.id}`] = {
              paths: macro.paths
            };
          });

  
          // fix added for non-converted placeholder campaigns
          for (const [key, analyticsValues] of Object.entries(analytics)) {
            if (key in vehicles) {
              for (const [key1, vehiclesValues] of Object.entries(vehicles)) {
                if (key === key1) {
                  vehiclesValues.analytics = analyticsValues.analytics
                  if (analyticsValues.paths) {
                    const mergedArray = [];
                    // Loop through each object in analyticsValues array
                    for (let i = 0; i < analyticsValues.paths.length; i++) {
                      let found = false;
                  
                      // Loop through each object in vehiclesValues array
                      for (let j = 0; j < vehiclesValues.paths.length; j++) {
                        // Check if there is an overlap in the start and end values
                        if (analyticsValues.paths[i].start === vehiclesValues.paths[j].start && analyticsValues.paths[i].end === vehiclesValues.paths[j].end) {
                          found = true;
                  
                          // Merge the objects by copying the distance and impressions keys
                          const mergedObject = { ...vehiclesValues.paths[j], distance: analyticsValues.paths[i].distance, impressions: analyticsValues.paths[i].impressions };
                          // Add the merged object to the mergedArray
                          mergedArray.push(mergedObject);
                  
                          // Break the loop as we found an overlap
                          break;
                        }
                      }
                  
                      // If no overlap was found, add the whole object from vehiclesValues.paths array
                      if (!found) {
                        mergedArray.push(analyticsValues.paths[i]);
                      }

                    }
                    vehiclesValues.paths = mergedArray
                  }
                }
              }
            } else {
              vehicles[key] = analyticsValues
            }
          }
        }
      }
    } catch (err) {
      console.log(err);
    }

    this.setState({
      loading: false
    });
    this.props.updateCampaignVehiclesMapBoxPaths(vehicles)
    return vehicles;
  }
  render() {
    return (
      <Fragment>
        <SideBar clientInpersonate={true} client={this.state.client} selected={this.props.match.params.campaign_id} setView={this.viewToggleHandler}/>
        <Content>
          <Switch>
          <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin/advertise/client/impersonate/:client_id/campaign/:campaign_id/map" component={MapPageTemp} />
          <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin/advertise/client/impersonate/:client_id/campaign/:campaign_id/analytics" component={AnalyticsPageTemp} />
          </Switch>
        </Content>
        <Loading loading={this.state.loading} label="Loading Client View..." />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.user.id,
    campaigns: state.clientDashboardTemp.campaigns,
    selected: state.clientDashboardTemp.selected,
    timePeriod: state.clientDashboardTemp.timePeriod,
    userProfileUrl: state.clientDashboardTemp.userProfileUrl
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCampaignLoad: (campaigns, selected) => {
      dispatch({
        type: actionTypes.LOAD_CLIENT_CAMPAIGNS,
        campaigns: campaigns,
        selected: selected
      });
    },
    resetState: () => {
      dispatch({
        type: actionTypes.RESET_CLIENT_DASHBOARD,
      });
    },
    updateCampaignVehiclesTemp: (campaignId, vehicles) => {
      dispatch({
        type: actionTypes.UPDATE_CAMPAIGN_VEHICLES_TEMP,
        id: campaignId,
        vehicles: vehicles,
      });
    },
    updateStartDate: (date, id) =>
      dispatch({
        type: actionTypes.UPDATE_START_DATE,
        startDate: date,
        id: id
      }),
      updateProfilePicture: (userProfileUrl) =>
      dispatch({
        type: actionTypes.UPDATE_PROFILE,
        userProfileUrl: userProfileUrl
      }),
      updateCampaignVehiclesMapBoxPaths: (vehicles) => {
        dispatch({
          type: actionTypes.UPDATE_CAMPAIGN_VEHICLES_MAPBOX,
          vehicles: vehicles
        });
      },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ClientImpersonationPageTemp));
